import { forwardRef, useCallback } from 'react';
import { ActionBar } from '@frontend/action-bar';
import { useTranslation } from '@frontend/i18n';
import { schedulePulseTrackingIds, useGetScheduleRequestAndAlertsCount } from '@frontend/schedule';
import { useTopBarStore, useTopBarShallowStore } from '../../store/use-top-bar-store';
import { TopBarFocusIds } from '../../utils/focus-registry';

export const SchedulePulseButton = forwardRef<HTMLButtonElement>((rest, ref) => {
  const { t } = useTranslation('base');
  const { isSchedulePulseOpen, setSchedulePulseOpen } = useTopBarShallowStore(
    'isSchedulePulseOpen',
    'setSchedulePulseOpen'
  );
  const { scheduleAlertsCount, scheduleRequestCount } = useGetScheduleRequestAndAlertsCount();

  const handleClick = useCallback(() => {
    setSchedulePulseOpen(!useTopBarStore.getState().isSchedulePulseOpen);
  }, [setSchedulePulseOpen]);

  return (
    <ActionBar.Action
      label={t('Schedule Pulse')}
      id={TopBarFocusIds.schedulePulse}
      icon='schedule-pulse'
      isActive={isSchedulePulseOpen}
      trackingId={schedulePulseTrackingIds.schedulePulseEventPanelIconButton}
      ref={ref}
      hasDot={!!scheduleAlertsCount || !!scheduleRequestCount?.total}
      {...rest}
      onClick={handleClick}
    />
  );
});
SchedulePulseButton.displayName = 'SchedulePulseButton';
